<template lang="pug">
.app-user-info
  .app-user-info-logout
    button(@click="logout" )
      v-icon(v-text="'logout'" color="white")
      span(v-text="'Sair'")
  .app-user-info-avatar
    v-avatar(color="blue" size="55")
      span(v-text="caracteresName")
    span.app-user-info-username(v-text="nameUser" class="mt-4")
  template
    v-expansion-panels
      v-expansion-panel
        v-expansion-panel-header.app-expansion-panel-header.mb-0
          span(v-text="'Mais informações'").app-user-info-panel
        v-expansion-panel-content
          .app-user-info-car
            div
              label.app-user-info-name(v-text="'Placa:'")
              div.app-user-info-name(v-text="user.placa")
            div
              label.app-user-info-name(v-text="'Modelo:'")
              div.app-user-info-name(v-text="user.modelo")
            div
              label.app-user-info-name(v-text="'Cor:'")
              div.app-user-info-name(v-text="user.cor")


</template>

<script>
import GlobalStore from '@/store/modules/global';
import AuthenticationService from '@/services/authentication.service';
export default {
  
  name: 'AppUserInfo',

  data: () => ({
    nameUser:'',
    caracteresName:''
  }),

  computed: {
    user: () => GlobalStore.user || {}
  },

  methods: {
    logout() {
      AuthenticationService.logout();
      GlobalStore.setSnackBar({
        show: true,
        message: 'Saiu do sistema com sucesso.',
        type: 'success'
      });
    },
    formatCaracteries(){

      const fullName = this.user.proprietario.split(" ")[0]
      const name = this.user.proprietario.split(" ")[0];
      const lengthName = this.user.proprietario.split(" ").length;
      const lastName = this.user.proprietario.split(" ")[lengthName-1];

      this.nameUser = name[0].toUpperCase() + name.slice(1).toLowerCase()+' '+lastName[0].toUpperCase() + lastName.slice(1).toLowerCase();
      this.caracteresName = name.substr(0,1)+lastName.substr(0,1)

    }
  },

  mounted() {
    this.formatCaracteries()
  }
  
};
</script>

<style>

.v-expansion-panel::before {
  box-shadow: none;
}

</style>
